module.exports = __webpack_public_path__ + "static/media/eventIcon.88b02ec4.png";